// eslint-disable-next-line no-shadow
export enum StyleProperty {
  BubbleCharInDelay = '--speech-bubble-char-in-delay',
  BubbleCharOutDelay = '--speech-bubble-char-out-delay',
  VhOffset = '--vh-offset'
}
